'use strict';function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');let

GroupsCommandAndQueryService=function(_BaseService){_inherits(GroupsCommandAndQueryService,_BaseService);
function GroupsCommandAndQueryService(socketService){_classCallCheck(this,GroupsCommandAndQueryService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._socketService=socketService;return _this;
}GroupsCommandAndQueryService.prototype.

_getGroupsCore=function(){var ref=_asyncToGenerator(function*(messageType){
let response=yield this._socketService.sendAndWaitForResponse(messageType);
if(!SocketResponse.succeeded(response)){
throw new Error('Unexpected error getting groups.');
}

return response.body.items;
});function _getGroupsCore(messageType){return ref.apply(this,arguments)}return _getGroupsCore}();GroupsCommandAndQueryService.prototype.

getGroupTree=function getGroupTree(){
return this._getGroupsCore('GetGroupTree');
};GroupsCommandAndQueryService.prototype.

getFlattenedGroups=function getFlattenedGroups(){
return this._getGroupsCore('GetFlattenedGroups');
};return GroupsCommandAndQueryService}(BaseService);


module.exports=GroupsCommandAndQueryService;
//# sourceMappingURL=groupsCommandAndQueryService.js.map
